// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e-_u","placeholdersHeader":"styles_placeholdersHeader__28uHM","editorStyle":"styles_editorStyle__PONHd","placeholdersBox":"styles_placeholdersBox__WFikW"};